import { render, staticRenderFns } from "./MobileHeaderLinks.vue?vue&type=template&id=21541470&scoped=true"
import script from "./MobileHeaderLinks.vue?vue&type=script&lang=js"
export * from "./MobileHeaderLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21541470",
  null
  
)

export default component.exports